import React, { useState, useRef, createRef, useEffect } from "react";

import {
    Box,
    Tabs,
    Tab,
    Card,
    CardActionArea,
    CardMedia,
    CardContent,
    Typography,
    CardActions,
    Button,
    Chip,
    Paper,
    Menu,
    MenuItem,
    Popper,
    Divider,
    Snackbar,
    Alert,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import { ReactComponent as BedIcon } from "../../assets/svgs/bed.svg";
import { ReactComponent as BathIcon } from "../../assets/svgs/bath.svg";
import { ReactComponent as SquareIcon } from "../../assets/svgs/square.svg";

import "./style.css";
import { DataTable } from "../DataTable";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { ImageSlider } from "../ImageSlider";
import { styled } from "@mui/material/styles";
import { config, styles } from "../../style";
import { ErrorScreen } from "../ErrorScreen";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { formatDateTimeRange } from "../../utils";
import TurnedInNotIcon from "@mui/icons-material/TurnedInNot";
import { SelfTourWaitlist } from "../SelfTourWaitlist";

const numberFormatter = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
});

const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: "none",
    minWidth: 0,
    zIndex: 1,
    [theme.breakpoints.up("sm")]: {
        minWidth: 0,
    },
    fontWeight: "600",
    marginRight: theme.spacing(1),
    color: "#1F4E66",
    "&:hover": {
        color: config.primaryColor,
        opacity: 1,
    },
    "&.Mui-selected": {
        color: config.primaryColor,
        fontWeight: "600",
    },
    "&.MuiTabs-indicator": {
        display: "none",
        //backgroundColor: "orange"
    },

    "&.Mui-focusVisible": {
        backgroundColor: config.primaryColor,
    },
}));

export default function Location(props) {
    const data = Array.from(props.locations);
    const [selectedTab, setSelectedTab] = React.useState("1");

    const inputRefs = useRef([]);

    const [anchorMarketEl, setAnchorMarketEl] = React.useState(null);
    const marketOpen = Boolean(anchorMarketEl);

    const [selectedRow, setSelectedRow] = React.useState();
    const [openToster, setOpenToster] = React.useState(false);
    const [tosterVariant, setTosterVariant] = useState("error");
    const [tosterMessage, setTosterMessage] = useState("");
    const [openSelfTour, setOpenSelfTour] = React.useState(false);
    const [currentListing, setCurrentListing] = React.useState();

    useEffect(() => {
        if (data.length > 0 && !selectedRow) {
            setSelectedRow({ data: data[0], index: 0 });
        }
    }, [data, selectedRow]);

    const handleTosterClose = () => {
        setOpenToster(false);
    };

    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const settings = {
        dots: true,
        fade: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 1500,
    };

    const getColumns = () => {
        let columns = [
            {
                name: "propertyAddress",
                label: "Address",
            },
            {
                name: "publicMarketLabel",
                label: "Market",
            },
            {
                name: "listRent",
                label: "Price",
                selector: (row) => formatter.format(row.listRent),
            },
            {
                name: "bedrooms",
                label: "Beds",
            },
            {
                name: "baths",
                label: "Baths",
            },
            {
                name: "yearBuilt",
                label: "Build",
            },
        ];

        return columns.map((item) => {
            return {
                name: item.label,
                selector: item.selector ? item.selector : (row) => row[item.name],
                sortable: false,
            };
        });
    };

    const handleSlide = (id) => {
        let imageRef = inputRefs.current?.find((item) => item.id === id);
        imageRef?.current?.start();
    };

    const handleStopSlide = (id) => {
        let imageRef = inputRefs.current?.find((item) => item.id === id);
        imageRef?.current?.stop();
    };
    const sortRecords = (records) => {
        let sortingValue = props?.selectedSorting;
        records.sort((a, b) => {
            let dataA = a[sortingValue.field] ? a[sortingValue.field] : "";
            let dataB = b[sortingValue.field] ? b[sortingValue.field] : "";
            dataA = dataA ? dataA : "";
            dataB = dataB ? dataB : "";
            dataA = isNaN(dataA) ? 0 : Number(dataA);
            dataB = isNaN(dataB) ? 0 : Number(dataB);
            let comparison = 0;
            if (dataA > dataB) {
                comparison = 1;
            } else if (dataA < dataB) {
                comparison = -1;
            }
            return sortingValue.order === "desc" ? comparison * -1 : comparison;
        });

        return [...records];
    };

    const getData = () => {
        let originalRecords = [...data];
        // if (props.selectedMarketRecord) {
        //     originalRecords = originalRecords.filter(
        //         (item) => item.publicMarketLabel === props.selectedMarketRecord.name
        //     );
        // }
        let records = sortRecords(originalRecords);
        inputRefs.current = records?.map((element, i) => ({ id: element.id, refdata: createRef(), element: element }));
        //setSelectedRow({ data: records[0], index: 0 });
        return records;
    };

    const hasData = () => {
        let originalRecords = [...data];
        // if (props.selectedMarketRecord) {
        //     originalRecords = originalRecords.filter(
        //         (item) => item.publicMarketLabel === props.selectedMarketRecord.name
        //     );
        // }
        return originalRecords && originalRecords?.length > 0;
    };

    const handleMarketMenuClick = (event) => {
        setAnchorMarketEl(event.currentTarget);
    };

    const handleMarketMenuClose = async (value) => {
        setAnchorMarketEl(null);
        if (props.onSortSelect) {
            props.onSortSelect(value);
        }
    };

    const getBadges = (item) => {
        let promotions = item?.promotions?.filter(
            (promotion) => new Date(promotion.startDate) <= new Date() && new Date() <= new Date(promotion.endDate)
        );
        let openHouses = item?.openHouses?.filter((openHouse) => new Date(openHouse.startDate) >= new Date());

        let displayComingSoon = item?.webListingStatus === "Coming Soon";

        let higlights = item?.propertyHighlights?.split(";");

        return (
            <Box sx={{ position: "absolute", top: "5px", left: "5px" }}>
                {promotions?.map((promotion) => (
                    <Chip
                        sx={{
                            background: "#1570EF",
                            height: "27px",
                            color: "white",
                            marginRight: "5px",
                            fontSize: "14px",
                            mt: "3px",
                        }}
                        label={promotion.name}
                    />
                ))}
                {higlights?.map((higlight) => (
                    <Chip
                        sx={{
                            background: "#1570EF",
                            height: "27px",
                            color: "white",
                            marginRight: "5px",
                            fontSize: "14px",
                            mt: "3px",
                        }}
                        label={higlight}
                    />
                ))}
                {openHouses?.map((openHouse) => (
                    <Chip
                        sx={{
                            background: "#17B26A",
                            height: "27px",
                            color: "white",
                            marginRight: "5px",
                            fontSize: "14px",
                            mt: "3px",
                        }}
                        label={
                            "Open " + formatDateTimeRange(new Date(openHouse.startDate), new Date(openHouse.endDate))
                        }
                    />
                ))}
                {displayComingSoon && (
                    <Chip
                        sx={{
                            background: "#17B26A",
                            height: "27px",
                            color: "white",
                            marginRight: "5px",
                            fontSize: "14px",
                            mt: "3px",
                        }}
                        label={"Coming Soon"}
                    />
                )}
            </Box>
        );
    };

    const displayPropertyDetails = (label, value) => {
        return (
            <Grid container spacing={0} sx={{ borderBottom: "1px solid #e5e5e5" }} justifyContent={"space-between"}>
                <Grid>
                    <Box sx={{ p: "10px", color: "#164C63", fontSize: "14px", fontWeight: "600" }}>{label}</Box>
                </Grid>
                <Grid>
                    <Box sx={{ p: "10px", color: "#1F4E66", fontSize: "14px", fontWeight: "400" }}>
                        {value ? value : "-"}
                    </Box>
                </Grid>
            </Grid>
        );
    };

    const handleApplyNowClick = (event, item) => {
        event.stopPropagation();
        event.preventDefault();
        window.open(process.env.REACT_APP_APPLY_NOW + "?recordId=" + item?.salesforceId);
    };

    const handleScheduleSelfTour = (event, listing) => {
        event.stopPropagation();
        event.preventDefault();
        if (listing?.selfShowingURL) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(listing?.selfShowingURL, "text/html");
            var anchorElement = doc?.querySelector("a");
            var url = anchorElement?.getAttribute("href");
            if (url) {
                window.open(url);
            }
        }
    };
    const handleSelfTourWaitlist = (event, item) => {
        event.stopPropagation();
        setOpenSelfTour(true);
        setCurrentListing(item);
    };

    const handleSelfTourWaitListClose = () => {
        setOpenSelfTour(false);
        setCurrentListing();
    };

    const handleComplete = (success) => {
        if (success) {
            setTosterVariant("success");
            setTosterMessage(`Thank you for your interest in this property. We will notify you as soon as tours open.`);
            setOpenToster(true);
        } else {
            setTosterVariant("error");
            setTosterMessage(
                `There was a problem with starting your application. Please contact support at (877) 958-1888.`
            );
            setOpenToster(true);
        }
    };

    const displayCard = (item, index, fullWidth) => {
        return (
            item && (
                <Card
                    onMouseOver={() => handleSlide(item?.id)}
                    onMouseOut={() => handleStopSlide(item?.id)}
                    onClick={() => props.onSelectListing(item)}
                    sx={{ "&:hover": { boxShadow: fullWidth ? "" : "0px 0px 0px 3px #33c3df" } }}>
                    <Grid container>
                        <Grid md={fullWidth ? 6 : 12} xs={fullWidth ? 12 : 12}>
                            <CardActionArea sx={{}}>
                                <Box
                                    sx={{
                                        minHeight: "200px",
                                        background: "#ececec",
                                        display: "flex",
                                        justifyContent: "center",
                                        justifyItems: "center",
                                        alignItems: "center",
                                    }}>
                                    {item?.assets?.filter((item) => item.fileId).length > 0 ? (
                                        <Box
                                            className="imgslider"
                                            sx={{ width: "100%", height: "200px", position: "relative" }}>
                                            <ImageSlider
                                                ref={inputRefs.current[index]}
                                                sx={{ height: "200px", width: "100%", objectFit: "cover" }}
                                                images={item?.assets
                                                    .filter((item) => item.fileId)
                                                    .map((item) => ({
                                                        url: process.env.REACT_APP_CLOUD_FRONT_URL + item.fileId,
                                                        alt: "image",
                                                        type: item.type,
                                                    }))}></ImageSlider>
                                        </Box>
                                    ) : (
                                        <MapsHomeWorkIcon
                                            sx={{ width: "7rem", height: "7rem", color: "white" }}></MapsHomeWorkIcon>
                                    )}
                                </Box>
                                {getBadges(item)}
                                <CardContent sx={{ color: config.brandColor }}>
                                    <Typography
                                        sx={{ color: config.brandColor }}
                                        gutterBottom
                                        variant="h5"
                                        component="div">
                                        {formatter.format(item?.listRent)}/mo{" "}
                                        <span style={{ fontSize: "14px", fontWeight: "400" }}>*plus required fees</span>
                                    </Typography>
                                    <Grid container spacing={3} justifyContent={"flex-start"}>
                                        <Grid item>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexWrap: "wrap",
                                                }}>
                                                <BedIcon></BedIcon>
                                                <span style={{ marginLeft: "7px" }}>{item?.bedrooms} Beds</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexWrap: "wrap",
                                                }}>
                                                <BathIcon></BathIcon>
                                                <span style={{ marginLeft: "7px" }}>{item.baths} Baths</span>
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexWrap: "wrap",
                                                }}>
                                                <SquareIcon></SquareIcon>
                                                <span style={{ marginLeft: "7px" }}>
                                                    {numberFormatter.format(item.squareFeet)} ft
                                                </span>
                                            </Typography>
                                        </Grid>
                                    </Grid>

                                    <Typography
                                        sx={{
                                            mt: ".5rem",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                        variant="body2">
                                        {item.propertyAddress}
                                    </Typography>

                                    <Grid container>
                                        <Grid item>
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexWrap: "wrap",
                                                    justifyContent: "center",
                                                    mt: "5px",
                                                }}>
                                                <TurnedInNotIcon
                                                    sx={{
                                                        width: "14px",
                                                        color: "#068ab2",
                                                        marginTop: "2px",
                                                    }}></TurnedInNotIcon>
                                                <span style={{ marginLeft: "7px" }}>
                                                    <i>{item.leaseType}</i>
                                                </span>
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                                {!fullWidth && (
                                    <CardActions
                                        sx={{
                                            borderTop: "1px solid #ededed",
                                            display: "flex",
                                            justifyContent: "space-around",
                                        }}>
                                        {item?.selfTourWorking ? (
                                            <Button
                                                sx={{ width: "60%" }}
                                                size="small"
                                                onClick={(event) => handleScheduleSelfTour(event, item)}>
                                                Schedule Self-Tour
                                            </Button>
                                        ) : (
                                            <Button
                                                sx={{ width: "60%" }}
                                                size="small"
                                                onClick={(event) => handleSelfTourWaitlist(event, item)}>
                                                Join Self-Tour Waitlist
                                            </Button>
                                        )}
                                        {<Divider orientation="vertical" flexItem></Divider>}
                                        <Button
                                            onClick={(event) => handleApplyNowClick(event, item)}
                                            size="small"
                                            sx={{ color: config.primaryColor, width: "40%" }}>
                                            Apply Now
                                        </Button>
                                    </CardActions>
                                )}
                            </CardActionArea>
                        </Grid>
                        {fullWidth && (
                            <Grid sx={{ borderLeft: "1px solid #e5e5e5" }} md={6} xs={12}>
                                {displayPropertyDetails("Property type", item.propertyType)}
                                {displayPropertyDetails("Roof type", item.roofType)}
                                {displayPropertyDetails("Parking", item.parking)}
                                {displayPropertyDetails("HVAC", item.HVACType)}
                                {displayPropertyDetails("Year build", item.yearBuilt)}
                                {displayPropertyDetails("Stories", item.numberOfStories ? item.numberOfStories : "-")}
                                {fullWidth && (
                                    <CardActions
                                        sx={{
                                            borderTop: "1px solid #ededed",
                                            display: "flex",
                                            justifyContent: "space-around",
                                        }}>
                                        {item?.selfTourWorking ? (
                                            <Button
                                                sx={{ width: "60%" }}
                                                size="small"
                                                onClick={(event) => handleScheduleSelfTour(event, item)}>
                                                Schedule Self-Tour
                                            </Button>
                                        ) : (
                                            <Button
                                                sx={{ width: "60%" }}
                                                size="small"
                                                onClick={(event) => handleSelfTourWaitlist(event, item)}>
                                                Join Self-Tour Waitlist
                                            </Button>
                                        )}
                                        <Divider orientation="vertical" flexItem></Divider>
                                        <Button
                                            onClick={(event) => handleApplyNowClick(event, item)}
                                            size="small"
                                            sx={{ color: config.primaryColor, width: "40%" }}>
                                            Apply Now
                                        </Button>
                                    </CardActions>
                                )}
                            </Grid>
                        )}
                    </Grid>
                </Card>
            )
        );
    };

    const handleOnRowSelect = (value, index) => {
        setSelectedRow({ data: value, index: index });
    };

    return (
        <div className="Location">
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "end",
                    fontSize: "14px",
                    fontWeight: "600",
                    marginLeft: "200px",
                    zIndex: "999",
                    position: "relative",
                }}>
                <Button
                    id="market-filter"
                    aria-controls={marketOpen ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    onClick={handleMarketMenuClick}
                    sx={{
                        ...styles.textButton,
                        fontWeight: "400",
                        marginTop: "-2px",
                        marginRight: { xs: "0px", md: "21px" },
                    }}
                    variant="outlined"
                    endIcon={<KeyboardArrowDownIcon />}>
                    {`Sort: `}{" "}
                    <b style={{ color: config.primaryColor, marginLeft: "4px" }}>{props?.selectedSorting?.label}</b>
                </Button>
                <Popper
                    sx={{
                        ...styles.popper,
                        minWidth: "100px",
                        zIndex: "1",
                        p: "0",
                    }}
                    id="market-filter"
                    open={marketOpen}
                    onClose={() => handleMarketMenuClose("")}
                    anchorEl={anchorMarketEl}>
                    {props?.sortOptions.map((item) => (
                        <MenuItem onClick={() => handleMarketMenuClose(item)} value={item.value}>
                            {item.label}
                        </MenuItem>
                    ))}
                </Popper>
                <Box sx={{ display: { xs: "none", md: "block" } }}>{getData().length} homes</Box>
            </Box>

            <TabContext value={selectedTab}>
                <Box sx={{ borderBottom: 1, borderColor: "divider", mt: "-40px" }}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                        <AntTab label="Photos" value="1" />
                        <AntTab label="List View" value="2" />
                    </TabList>
                </Box>
                {hasData() && (
                    <TabPanel value="1" sx={{ padding: "24px 0px" }}>
                        <Grid container spacing={2}>
                            {getData().map((item, index) => (
                                <Grid key={item.id} xs={12} md={6}>
                                    {displayCard(item, index)}
                                </Grid>
                            ))}
                        </Grid>
                    </TabPanel>
                )}

                {hasData() && (
                    <TabPanel value="2" sx={{ padding: "24px 0px" }}>
                        {displayCard(selectedRow?.data, selectedRow?.index, true)}
                        <Box sx={{ mt: "1rem" }}>
                            <DataTable
                                sx={{ maxHeight: "400px", overflow: "auto" }}
                                columns={getColumns()}
                                data={getData()}
                                onSelect={handleOnRowSelect}></DataTable>
                        </Box>
                    </TabPanel>
                )}
            </TabContext>
            <SelfTourWaitlist
                listing={currentListing}
                open={openSelfTour}
                onClose={handleSelfTourWaitListClose}
                onComplete={handleComplete}></SelfTourWaitlist>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={openToster}
                autoHideDuration={6000}
                sx={{ zIndex: 999900 }}
                onClose={handleTosterClose}>
                <Alert onClose={handleTosterClose} severity={tosterVariant} variant="filled">
                    {tosterMessage}
                </Alert>
            </Snackbar>
            {!hasData() && <ErrorScreen></ErrorScreen>}
        </div>
    );
}
